import React, { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Modal, Button, Form, InputNumber, Spin, notification, Switch, DatePicker } from 'antd';
import moment from 'moment';

import ServiceSelect from "../../../../components/ServiceSelect"
import MeasurementUnitSelect from '../../../../components/MeasurementUnitSelect';

import _service from '@netuno/service-client';

const langContext = 'reserved-area.service'

export default ({ onClose, service_uid, uid, onLoad }) => {

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    if (uid) {
      setLoading(true);
      _service({
        method: 'GET',
        url: '/client/service',
        data: { uid },
        success: (response) => {
          const newData = {
            service_uid: response.json.service_type.uid,
            price: response.json.price,
            measurement_unit_uid: response.json.measurement_unit.uid,
            own_transport: response.json.own_transport,
            estimated_date: moment(response.json.estimated_date, 'YYYY-MM-DD'),
          }
          setData(newData);
          setLoading(false);
        },
        fail: (e) => {
          notification["error"]({
            message: 'Erro no carregamento dos dados do Serviço',
            description: e.response.json.error,
          });
        }
      });
    }
  }, []);

  function onFinish(values) {
    setSubmitting(true);
    const { service_uid, measurement_unit_uid, price, own_transport } = values;
    const estimated_date = values.estimated_date.format('YYYY-MM-DD');
    if (uid) {
      _service({
        method: 'POST',
        url: '/client/service',
        data: {
          uid,
          measurement_unit_uid,
          price,
          service_uid,
          own_transport,
          estimated_date
        },
        success: (response) => {
          if (response.json.result) {
            notification["success"]({
              message: 'Serviço editado com sucesso.',
            });
            setLoading(false);
            setSubmitting(false);
            setIsModalVisible(false);
            if (onLoad) {
              onLoad();
            }
            if (onClose) {
              onClose();
            }
          } else {
            notification["warning"]({
              message: 'Não foi possível editar o serviço.',
              description: response.json.error,
            });
            setSubmitting(false);
          }
        },
        fail: (e) => {
          notification["error"]({
            message: 'Não foi possível editar o Serviço, contacte-nos através do chat de suporte.'
          });
        }
      });
    }
    else {
      _service({
        method: 'PUT',
        url: '/client/service',
        data: {
          service_uid,
          measurement_unit_uid,
          price,
          own_transport,
          estimated_date
        },
        success: (response) => {
          if (response.json.result) {
            notification["success"]({
              message: 'Serviço criado com sucesso.',
            });
            setLoading(false);
            setSubmitting(false);
            setIsModalVisible(false);
            if (onLoad) {
              onLoad();
            }
            if (onClose) {
              onClose();
            }

          } else {
            notification["warning"]({
              message: 'O Serviço não foi criado com sucesso.',
              description: response.json.error,
            });
            setSubmitting(false);
          }
        },
        fail: (e) => {
          notification["error"]({
            message: 'Não foi possível guardar o Serviço, contacte-nos através do chat de suporte.'
          });
        }
      });
    }
  }

  const intl = useIntl();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    if (onClose) {
      onClose()
    }
  };
  const onSubmit = () => {
    setSubmitting(true);
    form.submit();
  };

  function onFinishFailed(errorInfo) {
    console.log('Failed:', errorInfo);
    setSubmitting(false);
  }

  const currentMaskPrice = (val) => {
    if (!val) return 0;
    return `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".").replace(/\.(?=\d{0,2}$)/g, ",");
  }

  const parserNumber = (val) => {
    if (!val) return 0;
    return Number.parseFloat(val.replace(/\$\s?|(\.*)/g, "").replace(/(\,{1})/g, ".")).toFixed(2)
  }
  
  return (
    <>
      <Modal title={intl.formatMessage({ id: langContext + '.title' })} visible={true} onOk={handleOk} onCancel={handleCancel}
        footer={[
          <Button onClick={handleCancel}>
            <FormattedMessage id={`${langContext}.button.cancel`} />
          </Button>,
          <Button type="primary" htmlType="submit" loading={submitting} onClick={onSubmit}>
            <FormattedMessage id={`${langContext}.button.save`} />
          </Button>]}
      >
        {loading ? <Spin /> :
          <Form
            form={form}
            layout='vertical'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={data}
          >
            <Form.Item
              label={intl.formatMessage({ id: langContext + '.fields.service' })}
              name={['service_uid']}
              rules={[
                { required: true }
              ]}
            >
              <ServiceSelect />
            </Form.Item>
            <Form.Item
              label={intl.formatMessage({ id: langContext + '.fields.price' })}
              name={['price']}
              rules={[
                { required: true }
              ]}

            >
              <InputNumber
                placeholder={intl.formatMessage({ id: langContext + '.fields.price' })}
                min={-1000000}
                formatter={(value) => currentMaskPrice(value)}
                parser={(value) => parserNumber(value)}
              />
            </Form.Item>
            <Form.Item
              label={intl.formatMessage({ id: 'components.measurement-unit-select.title' })}
              name={['measurement_unit_uid']}
              rules={[
                { required: true }
              ]}
            >
              <MeasurementUnitSelect />
            </Form.Item>
            <Form.Item
              name={'own_transport'}
              label={intl.formatMessage({ id: 'reserved-area.construction.fields.own-transport' })}
            >
              {
                data.own_transport ? (<Switch defaultChecked />) : (<Switch />)
              }
            </Form.Item>
            <Form.Item
              name={'estimated_date'}
              label={intl.formatMessage({ id: 'reserved-area.construction.fields.estimated-date' })}
              rules={[
                { required: true },
                { type: 'date' }
              ]}
            >
              <DatePicker />
            </Form.Item>
          </Form>
        }
      </Modal>
    </>
  );
}


